<template>
  <button type="button" class="cs-item" @click="emit('select')">
    <SvgIcon name="svg/cs_agent.svg" class="cs-item__avatar" size="24px" />
    <span class="cs-item__title">{{ title }}</span>
    <SvgIcon name="svg/arrow_right.svg" class="cs-item__arrow" size="15px" />
  </button>
</template>

<script setup lang="ts">
import SvgIcon from '@/components/SvgIcon.vue'

defineProps<{
  /** 客服名称，例如 Live Chat CS 01 */
  title: string
}>()

const emit = defineEmits<{
  /** 点击该客服项 */
  (e: 'select'): void
}>()
</script>

<style scoped lang="scss">
.cs-item {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  height: 45px;
  padding: 0 10px;
  border: none;
  border-radius: 10px;
  background: var(--tr-01, #282828);
  color: #fff;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #333130;
  }

  &__avatar {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  }

  &__title {
    flex: 1;
    text-align: left;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__arrow {
    flex-shrink: 0;
    width: 15px;
    height: 15px;
    color: rgba(255, 255, 255, 0.6);
  }
}
</style>
